/* TRH 2026-10-30 visual consistency: one card / total / breakdown style for every calculator (drapery, outdoor, roman, cushion, pillow, bolster, add-on).
   Only presentation; no pricing logic. Injected once, last in <head>, so theme/snippet label & list styles can't change the cards. */
(function () {
  if (window.__trhDc3Lock) return; window.__trhDc3Lock = 1;
  var P = 'html body .trh-dc3-options ';
  var css = [
    '.trh-dc3-options{container-type:inline-size;text-align:left}',
    P + '.trh-dc3-card,' + P + '.trh-dc3-card *{font-family:inherit!important;letter-spacing:normal!important;text-transform:none!important;font-style:normal!important}',
    P + '.trh-dc3-card{font-size:12px!important;line-height:1.35!important;color:#333!important;font-weight:400!important;text-align:left!important;margin:0!important}',
    P + '.trh-dc3-card__t{font-size:14px!important;font-weight:700!important;line-height:1.3!important;color:#252525!important;margin:0 0 2px!important}',
    P + '.trh-dc3-card__s{font-size:11.5px!important;line-height:1.35!important;color:#777!important;margin:0 0 6px!important;font-weight:400!important}',
    P + '.trh-dc3-card ul{list-style:none!important;margin:0 0 6px!important;padding:0!important}',
    P + '.trh-dc3-card li{font-size:12px!important;line-height:1.4!important;color:#333!important;margin:0 0 2px!important;padding:0!important;font-weight:400!important;list-style:none!important}',
    P + '.trh-dc3-card li::before,' + P + '.trh-dc3-card li::marker{content:none!important}',
    P + '.trh-dc3-card li b{font-weight:700!important}',
    P + '.trh-dc3-card__p{font-size:16px!important;font-weight:700!important;line-height:1.3!important;color:#28a745!important}',
    P + '.trh-dc3-each{display:block!important;font-size:11px!important;font-weight:400!important;color:#777!important}',
    P + '.trh-dc3-det,' + P + '.trh-dc3-det summary{font-size:11px!important;line-height:1.4!important;padding:0!important;border:0!important;background:none!important}',
    P + '.trh-dc3-det{margin:4px 0 0!important}' ,
    P + '.trh-dc3-det summary{margin:0!important;display:list-item!important}',
    P + '.trh-dc3-det summary{color:#7C8C74!important}',
    P + '.trh-dc3-badge{font-size:10px!important;line-height:1.4!important;font-weight:700!important;color:#333!important;background:#DDC762!important;border-radius:8px!important;padding:1px 7px!important;top:-9px!important;right:8px!important}',
    P + '.trh-dc3-min{font-size:11px!important;color:#b45309!important}',
    P + '.trh-dc3-head{font-size:13px!important;line-height:1.5!important;color:#555!important;font-weight:400!important;margin:4px 0 8px!important}',
    'html body .trh-dc3-total{font-family:inherit!important;font-size:20px!important;font-weight:700!important;line-height:1.3!important;color:#28a745!important;margin:14px 0 8px!important;letter-spacing:normal!important;text-transform:none!important}',
    'html body .trh-dc3-break{font-family:inherit!important;font-size:14px!important;line-height:1.7!important;color:#7C8C74!important;font-weight:400!important;text-align:left!important;border-top:1px solid #ddd!important;padding-top:8px!important}',
    'html body .trh-dc3-break p{margin:0!important;font-size:14px!important;line-height:1.7!important}',
    /* one layout: a column narrower than 440px (every calculator column on desktop, and every phone) gets the stacked row cards */
    '@container (max-width:440px){',
    '  ' + P + '.trh-dc3-grid{grid-template-columns:1fr!important;gap:10px!important}',
    '  ' + P + '.trh-dc3-card{display:grid!important;grid-template-columns:1fr auto;column-gap:12px;padding:12px!important}',
    '  ' + P + '.trh-dc3-card.is-sel{padding:11px!important}',
    '  ' + P + '.trh-dc3-card__t,' + P + '.trh-dc3-card__s,' + P + '.trh-dc3-card ul{grid-column:1}',
    '  ' + P + '.trh-dc3-card__p{grid-column:2;grid-row:1 / span 3;align-self:center;text-align:right!important;font-size:17px!important}',
    '  ' + P + '.trh-dc3-det{grid-column:1 / -1}',
    '}',
    /* add-on: same price colour / weight as the calculator cards */
    'html body .trh-pa__sum b,html body .trh-pa__ok b{color:#28a745!important;font-weight:700!important}'
  ].join('\n');
  function inject() {
    if (document.getElementById('trh-dc3-lock')) return;
    var s = document.createElement('style'); s.id = 'trh-dc3-lock'; s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }
  inject();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inject);
  window.addEventListener('load', function () { var s = document.getElementById('trh-dc3-lock'); if (s && s !== document.head.lastElementChild) document.head.appendChild(s); });
})();
/* TRH 2026-10-30 shared pattern-repeat box (identical block in every TRH calculator file).
 * Store fabrics: prefilled from the fabric's metafields / description, visible and editable by the customer.
 * Edits write straight into that fabric's details object, so every calculator's existing repeat math uses them. */
(function () {
  if (window.TRHRepeatBox) return;
  var CSS = '.trh-rpt{display:none;margin:6px 0 6px;padding:8px 10px;border:1px solid #e0dbd1;border-radius:8px;background:#faf8f4;font-weight:normal;text-align:left}' +
    '.trh-rpt__row{display:flex;flex-wrap:wrap;gap:8px}' +
    '.trh-rpt label{display:flex;flex-direction:column;gap:2px;font-size:12px;color:#555;flex:1 1 110px;margin:0;font-weight:normal}' +
    '.trh-rpt input,.trh-rpt select{font:inherit;font-size:13px;padding:5px 7px;border:1px solid #cfc9bf;border-radius:5px;background:#fff;width:100%;box-sizing:border-box;margin:0;height:auto}' +
    '.trh-rpt__t{font-size:12.5px;color:#252525;margin:0 0 6px;font-weight:600}.trh-rpt__h{font-size:11.5px;color:#777;margin:6px 0 0;line-height:1.4}';
  function num(v) { var n = parseFloat(v); return n > 0 ? Math.round(n * 1000) / 1000 : 0; }
  function selOf(m) { return m.match === 'drop' ? (m.drop === 0.25 ? 'quarter-drop' : 'half-drop') : (m.match === 'random' ? 'random' : 'straight'); }
  function applySel(m, s) {
    if (s === 'half-drop') { m.match = 'drop'; m.drop = 0.5; } else if (s === 'quarter-drop') { m.match = 'drop'; m.drop = 0.25; }
    else if (s === 'random') { m.match = 'random'; m.drop = 0; } else { m.match = 'straight'; m.drop = 0; }
  }
  function toIn(n, unit) { n = parseFloat(n); if (!(n > 0)) return 0; if (/cm/i.test(unit || '')) n = n / 2.54; return Math.round(n * 1000) / 1000; }
  /* repeat info written in a product description, e.g. "Vertical Repeat: 46.25 in", "Repeat: 25.25\" V x 13.5\" H", "Half Drop" */
  function parseText(t) {
    if (!t) return null;
    t = String(t).replace(/<[^>]*>/g, ' ').replace(/&quot;|\u201d|\u2033/g, '"').replace(/\s+/g, ' ');
    var N = '(\\d+(?:\\.\\d+)?)\\s*(cm|in\\.?|inches|")?';
    var r = { vr: 0, hr: 0, match: null, drop: 0 };
    var vh = t.match(new RegExp('repeat\\s*[:\\-]?\\s*' + N + '\\s*v(?:ert(?:ical)?)?\\.?\\s*(?:x|by|,)\\s*' + N + '\\s*h', 'i'));
    if (vh) { r.vr = toIn(vh[1], vh[2]); r.hr = toIn(vh[3], vh[4]); }
    var v = t.match(new RegExp('(?:vertical|vert\\.?|\\bv\\.)\\s*repeat\\s*[:\\-]?\\s*' + N, 'i'));
    var h = t.match(new RegExp('(?:horizontal|horiz\\.?|\\bh\\.)\\s*repeat\\s*[:\\-]?\\s*' + N, 'i'));
    if (!r.vr && v) r.vr = toIn(v[1], v[2]);
    if (!r.hr && h) r.hr = toIn(h[1], h[2]);
    if (!r.vr) { var g = t.replace(/(?:horizontal|horiz\.?|\bh\.)\s*repeat/ig, '').match(new RegExp('\\brepeat\\s*[:\\-]?\\s*' + N, 'i')); if (g) r.vr = toIn(g[1], g[2]); }
    if (/half[\s-]*drop/i.test(t)) { r.match = 'drop'; r.drop = 0.5; }
    else if (/quarter[\s-]*drop/i.test(t)) { r.match = 'drop'; r.drop = 0.25; }
    else if (/straight\s*(?:match|across)/i.test(t)) r.match = 'straight';
    else if (/random\s*match|free\s*match/i.test(t)) r.match = 'random';
    return (r.vr || r.hr || r.match) ? r : null;
  }
  function css() { if (document.getElementById('trhRptCss')) return; var s = document.createElement('style'); s.id = 'trhRptCss'; s.textContent = CSS; document.head.appendChild(s); }
  /* show the box for `meta` (a store fabric's details) after `anchor`; onChange() re-runs the calculator */
  function attach(id, anchor, meta, onChange) {
    if (!anchor || !anchor.parentNode) return;
    css();
    var box = document.getElementById(id);
    if (!box) {
      box = document.createElement('div'); box.id = id; box.className = 'trh-rpt';
      box.innerHTML = '<p class="trh-rpt__t">Pattern repeat</p><div class="trh-rpt__row">' +
        '<label>Vertical repeat (inches)<input type="number" min="0" step="any" inputmode="decimal" data-rpt="vr" placeholder="0 = plain"></label>' +
        '<label>Horizontal repeat (inches)<input type="number" min="0" step="any" inputmode="decimal" data-rpt="hr" placeholder="0 = plain"></label>' +
        '<label>Pattern match<select data-rpt="m"><option value="straight">Straight match</option><option value="half-drop">Half-drop match</option><option value="random">Random / plain</option></select></label>' +
        '</div><p class="trh-pm-help" style="display:block;font-size:11.5px;color:#777;line-height:1.4;font-weight:normal;margin:4px 0 0">Not sure? Check your fabric\u2019s label or listing. Motifs in level rows across the fabric = Straight. Motifs staggered diagonally = Half-drop (uses a little more fabric). Solids, linens and textures = Random.</p><p class="trh-rpt__h"></p>';
      anchor.parentNode.insertBefore(box, anchor.nextSibling);
      var upd = function () {
        var m = box._meta; if (!m) return;
        m.vr = num(box.querySelector('[data-rpt=vr]').value); m.hr = num(box.querySelector('[data-rpt=hr]').value);
        applySel(m, box.querySelector('[data-rpt=m]').value); m.edited = true;
        if (box._cb) box._cb();
      };
      box.addEventListener('input', upd); box.addEventListener('change', upd);
    }
    box._cb = onChange;
    if (!meta) { box._meta = null; box.style.display = 'none'; return; }
    if (box._meta !== meta) {
      box._meta = meta;
      if (!meta.auto) meta.auto = { vr: meta.vr || 0, hr: meta.hr || 0 };
      box.querySelector('[data-rpt=vr]').value = meta.vr > 0 ? meta.vr : '';
      box.querySelector('[data-rpt=hr]').value = meta.hr > 0 ? meta.hr : '';
      var sel = box.querySelector('[data-rpt=m]'), sv = selOf(meta);
      if (sv === 'quarter-drop' && !sel.querySelector('option[value="quarter-drop"]')) { var o = document.createElement('option'); o.value = 'quarter-drop'; o.textContent = 'Quarter-drop match'; sel.appendChild(o); }
      sel.value = sv;
      box.querySelector('.trh-rpt__h').textContent = (meta.auto.vr > 0 || meta.auto.hr > 0)
        ? 'Filled in from this fabric\u2019s details. Change it if your fabric label or sample shows a different repeat; we add the yardage needed to match and center the pattern.'
        : 'No repeat on file for this fabric. If it has a pattern, enter the repeat from the fabric label or sample (leave blank for plain fabric) and we add the yardage needed to match and center it.';
    }
    box.style.display = 'block';
  }
  function hide(id) { var b = document.getElementById(id); if (b) b.style.display = 'none'; }
  window.TRHRepeatBox = { attach: attach, hide: hide, parseText: parseText };
})();

/**
 * TRH Drapery Calculator v3 (2026-10-30)
 * =========================================================================
 * Shared by snippets/trh-drapery-form.liquid (indoor drapery) and
 * snippets/trh-outdoor-curtain-form.liquid (outdoor curtains, mode 'outdoor').
 *
 * What it does
 *   - Recalculates live on every input change (no stale price can reach the cart;
 *     Add to Cart recomputes from the current inputs before it posts).
 *   - Shows three panel options side by side: Single width, Width and a half,
 *     Double width panels. Each shows panels, fabric widths/cuts, cut length,
 *     yardage (whole units, fabric minimum respected) and price. The client
 *     picks one; that option goes to the cart.
 *   - Pattern repeat: the cut length is rounded up to whole vertical repeats
 *     (half-drop: to an odd number of half repeats, so alternate widths match),
 *     read automatically from the fabric's custom.* metafields.
 *   - Railroaded / wide goods: cut seamless across the roll when the cut length
 *     fits within the fabric width.
 *   - COM: the client enters their fabric's width, vertical repeat and match;
 *     they see how much to send and pay labor + options only.
 *   - Full workroom detail goes to the cart as line item properties.
 *
 * Exposes window.TRHDraperyCalculator (init, calculate, getState, compute).
 */
(function () {
  'use strict';

  function FM() {
    return window.TRHFabricMin || {
      qty: function (y) { return Math.max(Math.ceil(y), 1); },
      info: function () { return { min: 1, unit: 'yard' }; },
      toUnits: function (y) { return Math.round(y * 1000) / 1000; },
      label: function (n) { return n + (n === 1 ? ' yard' : ' yards'); },
      abbr: function () { return 'yd'; },
      per: function () { return '/yd'; }
    };
  }

  /* ------------------------------------------------------------------ constants */
  var FULLNESS_MAP = {
    'Flat Panel': 1,
    'Flat Panel w/ Grommets': 2,          /* Rachel 2026-10-30: grommet 2x */
    'Flat Panel w/ Rod Pocket': 1,
    'Flat Panel w/ Back Tab': 1,
    'Ripple Fold': 2.2,                   /* Rachel 2026-10-30: ripple fold 2.2x */
    'Finger Pleat (1.5x Fullness)': 1.5,
    'Cartridge Pleat (2x Fullness)': 2,
    'Goblet Pleat (2x Fullness)': 2,
    'Tailored Pleat (2.5x Fullness)': 2.5,
    'Finger Pleat (2x Fullness)': 2,
    'Windsor Pleat (2x Fullness)': 2,
    'French 2 Finger Pleat (2x Fullness)': 2,
    'Inverted Pleat (2.5x Fullness)': 2.5,
    'Butterfly Pleat (2x Fullness)': 2,
    'French Pleat (2.5x Fullness)': 2.5,
    'Finger Pleat (2.5x Fullness)': 2.5,
    'Finger Pleat (3x Fullness)': 3,
    'Finger Pleat (3.5x Fullness)': 3.5
  };
  /* headings that carry the per-pleat (or per-grommet / per-snap) surcharge, as before */
  var PLEAT_STYLES = [
    'Flat Panel w/ Grommets', 'Ripple Fold', 'Finger Pleat (1.5x Fullness)', 'Finger Pleat (2x Fullness)',
    'Finger Pleat (2.5x Fullness)', 'Finger Pleat (3x Fullness)', 'Finger Pleat (3.5x Fullness)',
    'French Pleat (2.5x Fullness)', 'French 2 Finger Pleat (2x Fullness)', 'Cartridge Pleat (2x Fullness)',
    'Goblet Pleat (2x Fullness)', 'Windsor Pleat (2x Fullness)', 'Butterfly Pleat (2x Fullness)',
    'Inverted Pleat (2.5x Fullness)', 'Tailored Pleat (2.5x Fullness)'
  ];
  /* Workroom labor is priced PER WIDTH of fabric sewn (US workroom standard, research.md #23-#30).
     Relative heading factors vs pinch/finger pleat = 1.00 from published per-width price lists. */
  var HEADING_FACTOR = {
    'Flat Panel': 0.90, 'Flat Panel w/ Rod Pocket': 0.90, 'Flat Panel w/ Back Tab': 1.20,
    'Flat Panel w/ Grommets': 1.10, 'Ripple Fold': 1.15,
    'Finger Pleat (1.5x Fullness)': 1, 'Finger Pleat (2x Fullness)': 1, 'Finger Pleat (2.5x Fullness)': 1,
    'Finger Pleat (3x Fullness)': 1, 'Finger Pleat (3.5x Fullness)': 1, 'French 2 Finger Pleat (2x Fullness)': 1,
    'Windsor Pleat (2x Fullness)': 1, 'French Pleat (2.5x Fullness)': 1.03, 'Tailored Pleat (2.5x Fullness)': 1.03,
    'Cartridge Pleat (2x Fullness)': 1.25, 'Goblet Pleat (2x Fullness)': 1.25, 'Inverted Pleat (2.5x Fullness)': 1.25,
    'Butterfly Pleat (2x Fullness)': 1.20
  };
  /* liner select values: 2 = standard white lining, 3 = blackout lining */
  var LINING = {
    2: { name: 'Standard white lining', perYard: 12, laborPct: 0.20 },
    3: { name: 'Blackout lining', perYard: 20, laborPct: 0.30 }
  };
  /* TRH 2026-10-30 interlining add-on (indoor, with white or blackout lining): priced like white lining,
     same cuts / yardage as the lining (finished length + 12"), labor 20% of the per-width rate x billable widths */
  var INTERLINING = { name: 'Interlining', perYard: 12, laborPct: 0.20 };
  var C = {
    LABOR_PER_WIDTH: 375,      /* $ per 54" width sewn, pinch/finger pleat, finished length up to 84" (TRH rate 2026-10-30 evening, was $280; before that $255) */
    LENGTH_BASE_IN: 84,        /* per-width rate covers finished lengths up to 84" */
    LENGTH_STEP_IN: 12,        /* each additional 12" (or part) of finished length ... */
    LENGTH_STEP_PCT: 0.15,     /* ... adds 15% to the per-width rate */
    BILLABLE_WIDTH_IN: 54,     /* wide goods are billed as flat width / 54", rounded up (Precision Draperies) */
    PLEATS_PER_WIDTH: 5,       /* workroom average, shown in details only (pleats are priced inside the per-width rate) */
    TRIM_LABOR_PER_INCH: 1.5,  /* unchanged; length now follows the finished edge(s) */
    LABOR_MINIMUM: 110,        /* workroom minimum per order line */
    MAX_WINDOWS: 20,           /* 'How many windows like this?' 1-20 */
    RETURN_IN: 3.5,            /* each side return (2 per window) */
    OVERLAP_IN: 5,             /* center overlap for a pair: 2.5" per leading edge (workroom range 2-3.5" per panel, research.md) */
    SIDE_HEMS_PER_PANEL: 6,    /* 1.5" double-turned side hem = 3" per edge, 6" per panel (research.md) */
    SEAM_IN: 1,                /* 1/2" seam allowance each side of a join -> 54" at 2x = 24 / 37 / 50.5" finished panels */
    HEM_HEADER_IN: 16,         /* 4" double bottom hem (8") + 4" double header (8") */
    LINING_WIDTH: 54,
    LINING_EXTRA_IN: 12,       /* lining cut = finished length + 12" */
    DEFAULT_WIDTH: 54,
    MIN_VALID_WIDTH: 20,
    MAX_VALID_WIDTH: 130,
    MAX_WIDTHS_PER_PANEL: 6,
    SEAMLESS_MIN_WIDTH: 96     /* goods this wide are cut seamless across the roll when the drop fits */
  };
  var OPTIONS = [
    { key: 'single', k: 1, title: 'Single Width Panels', sub: 'Each panel made from 1 width of fabric' },
    { key: 'half', k: 1.5, title: 'Width & a Half Panels', sub: 'Each panel made from 1\u00bd widths of fabric' },
    { key: 'double', k: 2, title: 'Double Width Panels', sub: 'Each panel made from 2 widths of fabric' }
  ];

  function optionFor(k) {
    var base = OPTIONS.filter(function (o) { return o.k === k; })[0];
    if (base) return base;
    var names = { 2.5: '2\u00bd Widths', 3: 'Triple Width', 3.5: '3\u00bd Widths', 4: '4 Widths', 4.5: '4\u00bd Widths', 5: '5 Widths', 5.5: '5\u00bd Widths', 6: '6 Widths' };
    return { key: 'w' + k, k: k, title: names[k] || (k + ' Widths'), sub: 'Each panel made from ' + fmtW(k) + ' widths of fabric' };
  }
  function fullnessLabel(f, target) {
    if (target < 1.5 && f < 1.5) return 'Flat (as designed)';
    if (f < 1.5) return 'Flat / skimpy';
    if (f < 1.95) return 'Light';
    if (f <= 2.55) return 'Full';
    return 'Very full';
  }

  /* ------------------------------------------------------------------ state */
  var cfg = { mode: 'indoor', draperyVariantId: null, storeDomain: '', storefrontToken: '', apiVersion: '2024-01' };
  var selectedFabric = null, selectedTrim = null;
  var fabricMeta = null;          /* { width, widthNote, vr, hr, match, drop, railroaded, raw } */
  var metaLoading = false, metaSeq = 0;
  var chosenKey = null;           /* user's card choice; null = auto (best fit) */
  var last = null;                /* last compute() result */
  var touched = {};

  /* ------------------------------------------------------------------ helpers */
  function $(id) { return document.getElementById(id); }
  function val(id) { var e = $(id); return e ? e.value : ''; }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function sanitize(str) {
    if (!str) return '';
    return String(str).replace(/[\r\n\t]+/g, ' ').replace(/"/g, "'").trim().slice(0, 500);
  }
  function cents(n) { return Math.round(n * 100); }
  function money(c) {
    var n = c / 100;
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function r2(n) { return Math.round(n * 100) / 100; }
  function fmtIn(n) { return (Math.round(n * 100) / 100) + '"'; }
  function fmtHalf(n) { /* nearest half inch, 36.5 -> 36\u00bd" */
    var h = Math.round(n * 2) / 2, whole = Math.floor(h);
    return (h - whole ? (whole ? whole : '') + '\u00bd' : String(whole)) + '"';
  }
  function fmtW(n) { /* 1.5 -> 1\u00bd */
    var whole = Math.floor(n), frac = n - whole;
    if (Math.abs(frac - 0.5) < 1e-9) return (whole ? whole : '') + '\u00bd';
    return String(r2(n));
  }

  /* Parse a measurement such as 54", 54 in, 53.5 inches, 54" (137.2 cm), 1 1/2", 26 \u00bd",
   * 9.12 in V x 14.25 in H, 137 cm. Returns inches or null. */
  function parseInches(s, wantVertical) {
    if (s == null) return null;
    s = String(s).trim();
    if (!s || /^(none|random|n\/a|-)$/i.test(s)) return null;
    if (wantVertical) {
      var vm = s.match(/([\d.\s\/\u00bc\u00bd\u00be]+)\s*(?:in|inches|")?\s*V\b/i);
      if (vm) s = vm[1];
    }
    var map = { '\u00bc': 0.25, '\u00bd': 0.5, '\u00be': 0.75 };
    var n = null, rest = s, mm;
    if ((mm = s.match(/^\s*(\d+)\s+(\d+)\s*\/\s*(\d+)/))) { n = parseInt(mm[1], 10) + parseInt(mm[2], 10) / parseInt(mm[3], 10); }
    else if ((mm = s.match(/^\s*(\d+)\s*\/\s*(\d+)/))) { n = parseInt(mm[1], 10) / parseInt(mm[2], 10); }
    else if ((mm = s.match(/^\s*(\d*\.?\d+)?\s*([\u00bc\u00bd\u00be])?/)) && (mm[1] || mm[2])) { n = (mm[1] ? parseFloat(mm[1]) : 0) + (mm[2] ? map[mm[2]] : 0); }
    if (n == null || !(n > 0)) return null;
    rest = s.slice(mm[0].length);
    var m = rest.match(/^\s*(cm|mm|in|inch|inches|")?/i) || [];
    m[5] = m[1];
    var unit = (m[5] || '').toLowerCase();
    if (unit === 'cm') n = n / 2.54;
    if (unit === 'mm') n = n / 25.4;
    return Math.round(n * 1000) / 1000;
  }

  function parseMatch(pm, railroadedRaw) {
    var t = String(pm || '').toLowerCase();
    var res = { match: 'straight', drop: 0, label: 'Straight match', railroaded: false };
    if (/railroad/.test(t)) res.railroaded = true;
    if (/half|offset|stagger/.test(t)) { res.match = 'drop'; res.drop = 0.5; res.label = 'Half-drop match'; }
    else if (/quarter/.test(t)) { res.match = 'drop'; res.drop = 0.25; res.label = 'Quarter-drop match'; }
    else if (/random|free|no side/.test(t)) { res.match = 'random'; res.label = 'Random / free match'; }
    if (/^\s*(yes|true|y)\s*$/i.test(String(railroadedRaw || ''))) res.railroaded = true;
    return res;
  }

  function checkWidth(w) {
    if (w == null || !(w > 0)) return { width: C.DEFAULT_WIDTH, note: 'Fabric width not on file; we used 54" and will confirm before cutting.' };
    if (w < C.MIN_VALID_WIDTH || w > C.MAX_VALID_WIDTH) {
      return { width: C.DEFAULT_WIDTH, note: 'The listed fabric width (' + r2(w) + '") looks incorrect; we used 54" and will confirm before cutting.' };
    }
    return { width: w, note: '' };
  }

  /* ------------------------------------------------------------------ core math (pure) */
  /**
   * in: { W, L, q, heading, split, fw, vr, match('straight'|'drop'|'random'), drop, railroaded,
   *       linerRate, trimPlacement, trimItem, ownTrim, fabric (store fabric object) | null, com (bool) }
   */
  /* Trim follows the finished edges it is sewn to. Vertical edges run the finished length L.
     Horizontal (bottom / picture-frame) trim is sewn to the hem while the panel is flat, before pleating,
     so it runs the FLAT hem width of every panel (hemW, per window) (RM Coco: premade horizontal trim
     1.5 yd per width). Pricing per window; yardage per window x windows. */
  function computeTrim(placement, e, L, hemW, panels, q) {
    var p = 0, y = 0;   /* e = number of leading edges (pair 2, one-way 1, stationary 1 per panel) */
    if (!placement || placement === 'none') return { pricing: 0, yardage: 0 };
    switch (placement) {
      case 'leading': case 'return': p = L * e; y = (L + 2) * e; break;
      case 'both': p = L * 2 * e; y = (L + 2) * 2 * e; break;
      case 'bottom': p = hemW; y = hemW + 2 * panels; break;
      case 'picture': p = L * 2 * e + hemW; y = (L + 2) * 2 * e + hemW + 2 * panels; break;
    }
    return { pricing: p * q, yardage: y * q, perWindow: p };
  }
  function trimMinYards(t) {
    if (!t) return 1;
    var n = 0;
    (t.tags || []).forEach(function (x) { x = String(x).toLowerCase(); if (x.slice(0, 4) === 'min-') { var v = parseInt(x.slice(4), 10); if (v > n) n = v; } });
    if (t.vendor === 'The ReBorn House' || /^TRH\d/i.test(String(t.title || ''))) return Math.max(5, n);
    return n > 1 ? n : 1;
  }

  function cutLength(L, vr, match, drop) {
    var base = L + C.HEM_HEADER_IN;
    if (!(vr > 0) || match === 'random') return { cut: base, repeats: 0, base: base, waste: 0, method: 'none' };
    var n = Math.ceil(base / vr - 1e-9);
    var straight = { cut: r2(n * vr), repeats: n, base: base, waste: 0, method: 'straight' };
    if (match === 'drop' && drop > 0) {
      var m = Math.max(0, Math.ceil(base / vr - drop - 1e-9));
      return { cut: straight.cut, repeats: n, base: base, waste: r2(drop * vr), method: 'drop',
               dropCut: r2((m + drop) * vr), dropRepeats: m + drop };
    }
    return straight;
  }
  /* total inches of roll for `cuts` widths of this cut, matching the pattern */
  function rollInches(cl, cuts) {
    if (cl.method !== 'drop') return { inches: cuts * cl.cut, cut: cl.cut, how: cl.method };
    /* workroom method: cut every odd width at one pattern point, shift half a repeat once, then cut every even width.
       Cut length stays whole repeats; the job needs one extra half repeat in total (not per cut). */
    var extra = cuts > 1 ? cl.waste : 0;
    return { inches: cuts * cl.cut + extra, cut: cl.cut, how: 'odd-even', note: extra ? 'odd and even widths cut separately, +' + extra + '" once for the drop' : '' };
  }


  function compute(inp) {
    var fullness = FULLNESS_MAP[inp.heading] || 1;
    var pleated = PLEAT_STYLES.indexOf(inp.heading) !== -1;
    var hf = HEADING_FACTOR[inp.heading] || 1;
    var stat = !!inp.stationary;                         /* stationary side panels: no coverage requirement */
    var returns = 2 * C.RETURN_IN, overlap = inp.split && !stat ? C.OVERLAP_IN : 0;
    var rod = stat ? 0 : inp.W + returns + overlap;                 /* finished width incl. returns + overlap */
    var need = rod * fullness;                           /* flat fabric across, before side hems */
    var fw = inp.fw;
    var q = inp.q;
    var cl = cutLength(inp.L, inp.vr, inp.match, inp.drop);
    var seamless = (inp.railroaded || fw >= C.SEAMLESS_MIN_WIDTH) && (inp.L + C.HEM_HEADER_IN) <= fw;
    var railroadTooNarrow = inp.railroaded && !seamless;
    var lining = LINING[inp.linerRate] || null;
    /* per-width labor rate for this length: base up to 84", +15% per additional 12" (or part) */
    var lenSteps = Math.max(0, Math.ceil((inp.L - C.LENGTH_BASE_IN) / C.LENGTH_STEP_IN - 1e-9));
    var lenFactor = 1 + C.LENGTH_STEP_PCT * lenSteps;
    var widthRate = C.LABOR_PER_WIDTH * lenFactor;       /* $ per width, before heading factor */

    /* panel count is fixed by the draw: pair = 2 panels (1 per side), one-way = 1 panel.
       Each panel must cover rod / panels; the cards are how each panel is MADE (widths of fabric). */
    var fixedPanels = stat ? Math.max(1, inp.statPanels || 2) : (inp.split ? 2 : 1), P = stat ? 0 : rod / fixedPanels;
    var flatOf = function (k) { return k * fw - C.SIDE_HEMS_PER_PANEL - (Math.ceil(k) - 1) * C.SEAM_IN; };
    /* Workroom finished (pleated) width per panel, Rachel's convention for 54" goods at 2x:
       1 width ~25", 1 1/2 widths ~35", 2 widths ~50" (each whole width ~25", a half width ~10").
       Scaled by fabric width / 54 and by 2 / heading fullness (grommet 2x, ripple fold 2.2x ...). */
    var finishedOf = function (k, w54) { var w = Math.floor(k + 1e-9); return (25 * w + (k - w > 1e-9 ? 10 : 0)) * ((w54 ? 54 : fw) / 54) * (2 / fullness); };
    var kmin = null;
    for (var kk = 1; kk <= C.MAX_WIDTHS_PER_PANEL + 1e-9; kk += 0.5) { if (finishedOf(kk) >= P * 0.975) { kmin = kk; break; } }
    if (stat) kmin = 1;
    /* stationary: Single (default), 1½ or Double widths per panel */
    var ks = stat ? [1, 1.5, 2] : (kmin !== null && kmin <= 2) ? [1, 1.5, 2]
      : (kmin !== null ? [kmin - 1, kmin - 0.5, kmin, kmin + 0.5].filter(function (k) { return k <= C.MAX_WIDTHS_PER_PANEL; })
                       : [C.MAX_WIDTHS_PER_PANEL - 1.5, C.MAX_WIDTHS_PER_PANEL - 1, C.MAX_WIDTHS_PER_PANEL - 0.5, C.MAX_WIDTHS_PER_PANEL]);
    var tooSkimpy = kmin === null;
    var OPTS = seamless && !stat ? [OPTIONS[0]] : ks.map(optionFor);
    var one = fixedPanels === 1;
    var opts = OPTS.map(function (o) {
      var res = { key: o.key, title: o.title, sub: o.sub, k: o.k, available: true };
      if (one) { res.title = res.title.replace(/ Panels$/, ' Panel'); res.sub = res.sub.replace(/^Each panel made/, 'Made'); }
      var panels = fixedPanels, totalWidths, cuts, achieved, perWinYards, hemW, billable, liningCuts, pooledYards = null;
      if (seamless && stat) {
        /* stationary panels in wide goods: same finished sizes as 54" widths, cut seamless across the roll */
        res.sub = 'Cut seamless across the roll, finished like ' + fmtW(o.k) + ' width' + (o.k === 1 ? '' : 's') + ' of 54" fabric';
        var run = o.k * 54;
        totalWidths = 0; cuts = panels; achieved = fullness;
        res.finishedWidth = r2(finishedOf(o.k, true)); res.panelWidth = res.finishedWidth;
        res.cutLength = r2(run);
        perWinYards = panels * run / 36;
        hemW = panels * (run - C.SIDE_HEMS_PER_PANEL);
        billable = Math.ceil(panels * run / C.BILLABLE_WIDTH_IN - 1e-9);
        liningCuts = billable;
      } else if (seamless) {
        res.title = one ? 'Seamless Panel' : 'Seamless Panels'; res.sub = 'Wide fabric cut across the roll (railroaded), no seams';
        var perPanelRun = need / panels + C.SIDE_HEMS_PER_PANEL;   /* inches of roll per panel */
        totalWidths = 0; cuts = panels; achieved = fullness;
        res.panelWidth = r2(P); res.finishedWidth = r2(P);
        res.cutLength = r2(perPanelRun);
        perWinYards = panels * perPanelRun / 36;
        hemW = panels * perPanelRun - panels * C.SIDE_HEMS_PER_PANEL;
        billable = Math.ceil(panels * perPanelRun / C.BILLABLE_WIDTH_IN - 1e-9);   /* flat width / 54", rounded up */
        liningCuts = billable;
      } else {
        res.flatWidth = r2(flatOf(o.k));
        res.finishedWidth = r2(finishedOf(o.k));
        res.panelWidth = stat ? res.finishedWidth : r2(P);
        totalWidths = panels * o.k;
        cuts = Math.ceil(totalWidths - 1e-9);
        achieved = stat ? fullness : fullness * res.finishedWidth / P;
        if (!stat && (achieved < 1 - 1e-9 || flatOf(o.k) < P)) { res.available = false; res.reason = 'Too narrow: ' + fmtW(o.k) + ' width' + (o.k === 1 ? '' : 's') + ' of fabric cannot cover a ' + fmtHalf(P) + ' panel.'; return res; }
        var roll = rollInches(cl, cuts);
        res.cutLength = roll.cut; res.dropNote = roll.note || '';
        perWinYards = roll.inches / 36;
        if (inp.vr > 0 && inp.match !== 'random') perWinYards += inp.vr / 36;  /* one repeat to place the pattern, per set */
        /* TRH 2026-10-30 repeats: identical windows are cut from one run of fabric, so the half-drop shift and the placement repeat are counted once per order, not once per window (no repeat = unchanged) */
        if (q > 1 && inp.vr > 0 && inp.match !== 'random') pooledYards = (rollInches(cl, cuts * q).inches + inp.vr) / 36;
        hemW = panels * flatOf(o.k);
        billable = fw > 60 ? Math.ceil(totalWidths * fw / C.BILLABLE_WIDTH_IN - 1e-9) : totalWidths;
        liningCuts = fw > 60 ? billable : cuts;            /* same count of 54" lining widths as face widths */
      }
      var fabricYards = pooledYards != null ? pooledYards : perWinYards * q;                   /* per-window cut lengths x sets, rounded up below */
      res.fullLabel = fullnessLabel(achieved, fullness);
      res.panels = panels * q; res.panelsPerWindow = panels; res.perSide = stat ? null : 1;
      res.totalWidths = totalWidths; res.cuts = cuts; res.achieved = r2(achieved);
      res.rawYards = Math.round(fabricYards * 1000) / 1000;
      res.billableWidths = billable;

      /* fabric */
      if (inp.com) {
        res.comYards = Math.ceil(fabricYards - 1e-9);
        res.fabricQty = 0; res.fabricC = 0;
      } else if (inp.fabric) {
        var units = FM().toUnits(fabricYards, inp.fabric);
        res.fabricQty = FM().qty(fabricYards, inp.fabric);
        res.minApplied = res.fabricQty > Math.ceil(units - 1e-9);
        res.fabricC = cents(inp.fabric.price * res.fabricQty);
      } else { res.fabricQty = 0; res.fabricC = 0; }

      /* trim follows the finished edges (horizontal runs = flat hem width of these panels) */
      var trim = computeTrim(inp.trimPlacement, stat ? panels : (inp.split ? 2 : 1), inp.L, hemW, panels, q);
      var trimLaborC = inp.trimPlacement && inp.trimPlacement !== 'none' ? cents(trim.pricing * C.TRIM_LABOR_PER_INCH) : 0;
      var trimYards = 0, trimC = 0;
      if (trim.yardage > 0) {
        trimYards = Math.max(Math.ceil(trim.yardage / 36 - 1e-9), inp.ownTrim ? 5 : trimMinYards(inp.trimItem));
        if (!inp.ownTrim && inp.trimItem) trimC = cents(inp.trimItem.price * trimYards);
      }

      /* lining (indoor only): same number of 54" widths as the face fabric, cut finished + 12" */
      var liningMatC = 0, liningLaborC = 0;
      if (lining) {
        res.liningCuts = liningCuts * q;
        res.liningYards = Math.ceil(liningCuts * (inp.L + C.LINING_EXTRA_IN) / 36 * q - 1e-9);
        liningMatC = cents(lining.perYard * res.liningYards);
        liningLaborC = cents(lining.laborPct * widthRate * billable * q);
      } else { res.liningYards = 0; res.liningCuts = 0; }
      var interMatC = 0, interLaborC = 0;
      if (lining && inp.interlining) {
        res.interliningYards = res.liningYards;
        interMatC = cents(INTERLINING.perYard * res.interliningYards);
        interLaborC = cents(INTERLINING.laborPct * widthRate * billable * q);
      } else res.interliningYards = 0;

      /* labor: per width sewn x length band x heading, x windows; never discounted for skimpy cards */
      var faceC = cents(widthRate * hf * billable * q);
      var laborRawC = faceC + liningLaborC + liningMatC + interLaborC + interMatC + trimLaborC;
      var laborDollars = Math.ceil(laborRawC / 100 - 1e-9);
      res.laborMinApplied = laborDollars < C.LABOR_MINIMUM;
      laborDollars = Math.max(laborDollars, C.LABOR_MINIMUM);
      res.laborDollars = laborDollars;
      res.pleats = pleated ? Math.round(billable * C.PLEATS_PER_WIDTH * q) : 0;
      res.breakdown = { faceC: faceC, liningLaborC: liningLaborC, liningMatC: liningMatC, trimLaborC: trimLaborC, interMatC: interMatC, interLaborC: interLaborC,
        widthRateC: cents(widthRate * hf), billable: billable * q, lenFactor: lenFactor, pleats: res.pleats };
      res.liningC = liningLaborC + liningMatC;
      res.interliningC = interLaborC + interMatC;
      res.trimYards = trimYards; res.trimC = trimC;
      res.totalC = laborDollars * 100 + res.fabricC + trimC;
      res.perWindowC = Math.round(res.totalC / q);
      return res;
    });

    var avail = opts.filter(function (o) { return o.available; });
    /* Recommended = closest to the heading's target fullness, preferring cards that reach it (within 0.1x) */
    var meets = avail.filter(function (o) { return o.achieved >= fullness - 0.1; });
    var best = (meets.length ? meets : avail).slice().sort(function (a, b) {
      return (Math.abs(a.achieved - fullness) - Math.abs(b.achieved - fullness)) || (b.achieved - a.achieved);
    })[0];
    if (stat) best = avail.filter(function (o) { return o.k === 1; })[0] || best;   /* stationary panels default to Single width */
    if (best) best.best = true;
    return {
      fullness: fullness, pleated: pleated, rod: r2(rod), need: r2(need), returns: C.RETURN_IN, overlap: overlap,
      cut: cl, seamless: seamless, railroadTooNarrow: railroadTooNarrow, options: opts, bestKey: best ? best.key : null,
      panels: fixedPanels, panelWidth: r2(P), tooSkimpy: tooSkimpy && !stat, stationary: stat, q: q,
      lenFactor: lenFactor, widthRate: widthRate, headingFactor: hf, lining: lining
    };
  }

  /* ------------------------------------------------------------------ inputs */
  function readInputs() {
    var own = $('ownFabric') && $('ownFabric').checked;
    var W = parseFloat(val('draperyWidth')), L = parseFloat(val('draperyLength'));
    var q = parseInt(val('draperyQuantity'), 10);
    var heading = val('pleatOption');
    var stationary = val('drawOption') === 'Stationary Side Panels';
    var split = val('drawOption') === 'Split Draw';
    var statPanels = parseInt(val('statPanels'), 10);
    if (stationary && !(W > 0)) W = 0;
    var linerRate = cfg.mode === 'outdoor' || !$('draperyLiner') ? 0 : (parseFloat(val('draperyLiner')) || 0);
    var interlining = cfg.mode !== 'outdoor' && linerRate > 0 && !!($('draperyInterlining') && $('draperyInterlining').checked);
    var trimPlacement = val('draperyTrim') || 'none';
    var ownTrim = $('ownTrim') && $('ownTrim').checked;
    var fw, vr = 0, match = 'straight', drop = 0, railroaded = false, widthNote = '', repeatSource = '';
    if (own) {
      fw = parseFloat(val('draperyFabricWidth'));
      vr = parseFloat(val('comRepeat')) || 0;
      var m = val('comMatch') || 'straight';
      match = m === 'half-drop' ? 'drop' : (m === 'none' ? 'random' : 'straight');
      drop = m === 'half-drop' ? 0.5 : 0;
      railroaded = !!($('comRailroaded') && $('comRailroaded').checked);
      repeatSource = 'your fabric';
    } else if (selectedFabric) {
      var fm = fabricMeta || {};
      var chk = checkWidth(fabricMeta && fabricMeta.raw ? fm.width : (selectedFabric.fabricWidth || null)); /* metafield is the source of truth once loaded */
      fw = chk.width; widthNote = chk.note;
      vr = fm.vr || 0; match = fm.match || 'straight'; drop = fm.drop || 0; railroaded = !!fm.railroaded;
      repeatSource = 'fabric details';
    }
    return {
      own: own, W: W, L: L, q: q, heading: heading, split: split, draw: val('drawOption'), linerRate: linerRate, interlining: interlining,
      stationary: stationary, statPanels: statPanels,
      trimPlacement: trimPlacement, ownTrim: ownTrim, fw: fw, vr: vr, match: match, drop: drop, railroaded: railroaded,
      widthNote: widthNote, repeatSource: repeatSource
    };
  }

  function inputProblems(i, forCart) {
    var p = [];
    if (!i.stationary && !(i.W >= 1)) p.push('widthError');
    if (i.stationary && !(i.statPanels >= 1 && i.statPanels <= 12)) p.push('statPanelsError');
    if (!(i.L >= 1)) p.push('lengthError');
    if (!(i.q >= 1 && i.q <= C.MAX_WINDOWS)) p.push('quantityError');
    if (!i.own && !selectedFabric) p.push('fabricError');
    if (i.own && !(i.fw >= C.MIN_VALID_WIDTH && i.fw <= C.MAX_VALID_WIDTH)) p.push('fabricWidthError');
    if (i.own && !(val('comRepeat') === '' || parseFloat(val('comRepeat')) >= 0)) p.push('comRepeatError');
    if (i.trimPlacement !== 'none' && !i.ownTrim && !selectedTrim) p.push('trimError');
    if (forCart) {
      if (!val('roomName').trim()) p.push('roomNameError');
      if (i.own && !val('customFabricName').trim()) p.push('customFabricNameError');
      if (i.ownTrim && i.trimPlacement !== 'none' && !val('customTrimName').trim()) p.push('customTrimNameError');
      if (i.heading === 'Flat Panel w/ Grommets' && !val('grommetColor')) p.push('grommetColorError');
    }
    return p;
  }
  var ERR_IDS = ['roomNameError', 'widthError', 'lengthError', 'fabricError', 'customFabricNameError', 'trimError',
    'customTrimNameError', 'fabricWidthError', 'quantityError', 'grommetColorError', 'comRepeatError', 'statPanelsError'];
  var ERR_FIELD = { roomNameError: 'roomName', widthError: 'draperyWidth', lengthError: 'draperyLength', quantityError: 'draperyQuantity',
    fabricWidthError: 'draperyFabricWidth', customFabricNameError: 'customFabricName', customTrimNameError: 'customTrimName',
    grommetColorError: 'grommetColor', comRepeatError: 'comRepeat', statPanelsError: 'statPanels', fabricError: 'singleFabricField', trimError: 'singleTrimField' };
  function showErrors(list, all) {
    ERR_IDS.forEach(function (id) {
      var e = $(id); if (!e) return;
      var on = list.indexOf(id) !== -1 && (all || touched[ERR_FIELD[id]]);
      e.style.display = on ? 'block' : 'none';
    });
  }

  /* ------------------------------------------------------------------ render */
  function chosen() {
    if (!last) return null;
    var key = chosenKey;
    var o = last.r.options.filter(function (x) { return x.key === key && x.available; })[0];
    return o || last.r.options.filter(function (x) { return x.key === last.r.bestKey; })[0] || null;
  }

  function unitLabel(n) { return selectedFabric && !last.i.own ? FM().label(n, selectedFabric) : (n + (n === 1 ? ' yard' : ' yards')); }

  function renderRepeatInfo(i) {
    var el = $('trhRepeatInfo'); if (!el) return;
    if (!i.own && !selectedFabric) { el.innerHTML = ''; if (window.TRHRepeatBox) window.TRHRepeatBox.hide('trhRptBox'); return; }
    if (!i.own && metaLoading) { el.innerHTML = 'Reading fabric details\u2026'; if (window.TRHRepeatBox) window.TRHRepeatBox.hide('trhRptBox'); return; }
    var parts = [];
    if (i.vr > 0 && i.match !== 'random') {
      parts.push('Pattern repeat used: <strong>' + fmtIn(i.vr) + ' vertical</strong>, ' + (i.match === 'drop' ? (i.drop === 0.25 ? 'quarter-drop' : 'half-drop') + ' match' : 'straight match') + ' (from ' + esc(i.repeatSource) + ').');
    } else if (i.vr > 0 && i.match === 'random') {
      parts.push('Pattern: random / free match, no repeat adjustment needed.');
    } else {
      parts.push('No vertical pattern repeat on file (plain or small-scale), so no repeat allowance is added.');
    }
    if (i.railroaded) parts.push('This fabric is railroaded (pattern runs across the roll).');
    if (i.widthNote) parts.push('<span style="color:#b45309">' + esc(i.widthNote) + '</span>');
    el.innerHTML = parts.join(' ');
    /* TRH 2026-10-30: editable repeat for store fabrics (own fabric uses the COM fields) */
    if (window.TRHRepeatBox) { if (!i.own && selectedFabric && fabricMeta && !metaLoading) window.TRHRepeatBox.attach('trhRptBox', el, fabricMeta, render); else window.TRHRepeatBox.hide('trhRptBox'); }
  }

  function laborLine(o, r, i) {
    var b = o.breakdown;
    return fmtW(b.billable) + ' width' + (b.billable === 1 ? '' : 's') + ' sewn' + (i.q > 1 ? ' (' + fmtW(o.billableWidths) + ' per window x ' + i.q + ')' : '') + ' x ' + money(b.widthRateC) + '/width' +
      ' (' + (i.L <= C.LENGTH_BASE_IN ? 'up to ' + C.LENGTH_BASE_IN + '"' : 'up to ' + (C.LENGTH_BASE_IN + C.LENGTH_STEP_IN * Math.round((r.lenFactor - 1) / C.LENGTH_STEP_PCT)) + '"') + ' long)';
  }
  function cardHtml(o, r, i, sel) {
    if (!o.available) {
      return '<div class="trh-dc3-card is-off" aria-disabled="true"><div class="trh-dc3-card__t">' + esc(o.title) + '</div>' +
        '<div class="trh-dc3-card__s">' + esc(o.reason || '') + '</div></div>';
    }
    var one = o.panelsPerWindow === 1, lines = [];
    lines.push('<li>' + (one ? 'Panel' : 'Each panel') + ' finishes about <b>' + fmtHalf(o.finishedWidth) + ' wide</b>' + (r.pleated ? ' (' + r.fullness + 'x)' : '') + '</li>');
    if (!r.stationary) lines.push('<li>Fullness on your window: <b>' + o.achieved + 'x &ndash; ' + esc(o.fullLabel) + '</b></li>');
    if (i.own) lines.push('<li>Send us <b>' + o.comYards + ' yards</b> of your fabric</li>');
    else lines.push('<li><b>' + esc(FM().label(o.fabricQty, selectedFabric)) + '</b> of fabric' + (o.minApplied ? ' <span class="trh-dc3-min">(incl. minimum)</span>' : '') + '</li>');
    var det = [];
    if (r.seamless) det.push(o.cuts * i.q + ' seamless cut' + (o.cuts * i.q === 1 ? '' : 's') + ' of ' + fmtIn(o.cutLength) + ' along the roll');
    else {
      det.push(fmtW(o.totalWidths) + ' width' + (o.totalWidths === 1 ? '' : 's') + ' = ' + o.cuts + ' cut' + (o.cuts === 1 ? '' : 's') + ' of ' + fmtIn(o.cutLength) + (i.q > 1 ? ' per window' : '') +
        (o.k % 1 && o.cuts > o.totalWidths ? ' (one cut split in half, half left over)' : (o.k % 1 ? ' (half-widths share a cut)' : '')) +
        (r.cut.repeats ? ', incl. ' + fmtIn(i.vr) + ' repeat' : ''));
    }
    if (!r.stationary) det.push((one ? 'Panel' : 'Each panel') + ' covers ' + fmtHalf(r.panelWidth) + ' of the rod incl. return' + (i.split ? ' & overlap' : ''));
    if (o.liningYards) det.push((/blackout/i.test((r.lining && r.lining.name) || '') ? 'Blackout lining included' : 'Lining included'));   /* TRH 2026-10-30: lining shown as included, no yardage */
    if (o.interliningYards) det.push('Interlining included');   /* TRH 2026-10-30 hide breakdown: no labor rates or lining cost shown */
    return '<label class="trh-dc3-card' + (sel ? ' is-sel' : '') + '">' +
      '<input type="radio" name="trhDc3Opt" value="' + o.key + '"' + (sel ? ' checked' : '') + '>' +
      (o.key === r.bestKey ? '<span class="trh-dc3-badge">Recommended</span>' : '') +
      '<div class="trh-dc3-card__t">' + esc(o.title) + '</div>' +
      '<div class="trh-dc3-card__s">' + esc(o.sub) + '</div>' +
      '<ul>' + lines.join('') + '</ul>' +
      '<div class="trh-dc3-card__p">' + money(o.totalC) + (i.q > 1 ? '<span class="trh-dc3-each">' + money(o.perWindowC) + ' per window x ' + i.q + '</span>' : '') + '</div>' +
      '<details class="trh-dc3-det"><summary>Workroom details</summary>' + det.map(esc).join('<br>') + '</details></label>';
  }

  function render() {
    var i = readInputs();
    renderRepeatInfo(i);
    var fwField = $('draperyFabricWidth');
    if (fwField && !i.own && selectedFabric && i.fw) fwField.value = i.fw;
    var probs = inputProblems(i, false);
    showErrors(probs, false);
    var box = $('trhOptions'), res = $('draperyResult'), btn = $('addToCartButton');
    if (probs.length || (!i.own && metaLoading)) {
      last = null;
      if (box) box.innerHTML = '<p class="trh-dc3-hint">' + (metaLoading && !probs.length ? 'Reading fabric details\u2026' :
        'Enter the window width and length and choose a fabric (or your own) to compare panel options.') + '</p>';
      if (res) res.innerHTML = '';
      if (btn) btn.disabled = true;
      updateBar();
      return;
    }
    var r = compute({
      W: i.W, L: i.L, q: i.q, heading: i.heading, split: i.split, fw: i.fw, vr: i.vr, match: i.match, drop: i.drop,
      railroaded: i.railroaded, linerRate: i.linerRate, interlining: i.interlining, trimPlacement: i.trimPlacement, trimItem: selectedTrim,
      stationary: i.stationary, statPanels: i.statPanels,
      ownTrim: i.ownTrim, fabric: i.own ? null : selectedFabric, com: i.own
    });
    last = { i: i, r: r };
    var o = chosen();
    if (box) {
      var wins = i.q > 1 ? ' Priced for ' + i.q + ' identical windows.' : '';
      var head = '<div class="trh-dc3-head">' + (r.stationary
        ? 'Stationary side panels: ' + r.panels + ' panel' + (r.panels === 1 ? '' : 's') + ' per window (decorative, they don\u2019t close). Choose how wide each panel is made:'
        : (r.panels === 2 ? 'Your pair: 2 panels (1 each side). Each panel' : 'Your one-way panel') +
          ' needs to cover about <b>' + fmtHalf(r.panelWidth) + '</b> of the rod for your ' + r2(i.W) + '" window. Choose how ' + (r.panels === 2 ? 'each panel is' : 'it is') + ' made' + (r.seamless ? '' : ' (more widths = fuller folds)') + ':') +
        wins + '</div>';
      var nOpt = r.options.length;
      box.innerHTML = head + '<div class="trh-dc3-grid" style="--trh-cols:' + (nOpt >= 4 ? 2 : nOpt) + '" role="radiogroup" aria-label="Panel options">' +
        r.options.map(function (x) { return cardHtml(x, r, i, o && x.key === o.key); }).join('') + '</div>' +
        (r.tooSkimpy ? '<p class="trh-dc3-note">This window is very wide for one panel per side. Even ' + C.MAX_WIDTHS_PER_PANEL + ' widths per panel is below the usual fullness for this heading; we recommend contacting us about extra panels or a wider fabric.</p>' : '') +
        (r.railroadTooNarrow ? '<p class="trh-dc3-note">This railroaded fabric is narrower than the drop, so it is figured in vertical widths; the pattern will run sideways. We will confirm with you.</p>' : '');
    }
    if (res && o) {
      var b = o.breakdown, rows = [];
      rows.push('<p class="trh-dc3-total">Total: ' + money(o.totalC) + '</p>');
      rows.push('<div class="trh-dc3-break">');
      if (i.q > 1) rows.push('<p><strong>Windows:</strong> ' + i.q + ' identical sets, ' + money(o.perWindowC) + ' per window</p>');
      /* TRH 2026-10-30 hide breakdown: customers see the total, their choices and yardage; no labor, rates or cost lines */
      if (i.own) rows.push('<p><strong>Fabric to send (your own):</strong> ' + o.comYards + ' yards</p>');
      else rows.push('<p><strong>Fabric:</strong> ' + esc(FM().label(o.fabricQty, selectedFabric)) + (o.minApplied ? ' (includes this fabric\u2019s ' + FM().info(selectedFabric).min + ' ' + FM().abbr(selectedFabric) + ' minimum)' : '') + '</p>');
      if (o.liningYards) rows.push('<p><strong>' + (/blackout/i.test((r.lining && r.lining.name) || '') ? 'Blackout lining included' : 'Lining included') + '</strong></p>');
      if (o.interliningYards) rows.push('<p><strong>Interlining included</strong></p>');
      if (i.trimPlacement !== 'none') rows.push('<p><strong>Trim:</strong> ' + o.trimYards + ' yards' + (i.ownTrim ? ' (your own)' : '') + '</p>');
      rows.push('<p class="trh-dc3-small">' + esc(o.title) + ': ' + o.panels + ' panel' + (o.panels === 1 ? ', about ' : 's, each about ') + fmtHalf(o.finishedWidth) + ' wide finished' + (r.stationary ? ' (stationary)' : ', ' + o.achieved + 'x fullness on the window (' + esc(o.fullLabel) + ')') + '.</p>');
      rows.push('</div>');
      res.innerHTML = rows.join('');
    }
    if (btn) btn.disabled = false;
    updateBar();
  }

  function updateBar() {
    var bar = $('trhDc3Bar'); if (!bar) return;
    var o = chosen();
    var s = bar.querySelector('.trh-dc3-bar__s'), b = bar.querySelector('button');
    if (o) { s.innerHTML = '<b>' + money(o.totalC) + '</b><br><span>' + esc(o.title) + '</span>'; b.disabled = false; }
    else { s.innerHTML = '<span>Enter sizes to see your price</span>'; b.disabled = true; }
  }

  /* ------------------------------------------------------------------ cart */
  function buildItems() {
    var i = last.i, r = last.r, o = chosen();
    var prefix = cfg.mode === 'outdoor' ? 'odc-' : 'drp-';
    var forWord = cfg.mode === 'outdoor' ? 'Custom Outdoor Curtain - ' : 'Custom Drapery - ';
    var gid = prefix + Date.now() + '-' + Math.random().toString(36).substr(2, 5);
    var room = sanitize(val('roomName')) || 'Not specified';
    var heading = i.heading;
    var props = {
      'Window Name': room,
      'Total Price': money(o.totalC),
      'Windows': i.q > 1 ? i.q + ' identical sets (' + money(o.perWindowC) + ' per window)' : '1 window',
      'Style': r.stationary ? 'Stationary side panels' : (i.split ? 'Pair (draw)' : 'One-way draw'),
      'Panel Option': o.title + (r.seamless && !r.stationary ? '' : ' (' + fmtW(o.k) + ' width' + (o.k === 1 ? '' : 's') + ' per panel)'),
      'Window Width': i.W > 0 ? r2(i.W) + ' in' + (r.stationary ? ' (info only)' : '') : 'Not given (stationary)',
      'Finished Length': r2(i.L) + ' in',
      'Rod Width (incl. returns/overlap)': r.stationary ? 'N/A (stationary panels)' : r.rod + ' in (returns ' + C.RETURN_IN + ' in x 2' + (i.split ? ', overlap ' + C.OVERLAP_IN + ' in' : '') + ')',
      'Heading': heading,
      'Fullness': r.stationary ? r.fullness + 'x (stationary, made at heading fullness)' : o.achieved + 'x (' + o.fullLabel + '); heading target ' + r.fullness + 'x',
      'Draw': i.draw,
      'Panels': o.panelsPerWindow + ' per window' + (i.split && !r.stationary ? ' (1 per side)' : '') + (i.q > 1 ? ', ' + o.panels + ' total' : '') + ', ' + (o.panelsPerWindow === 1 ? '' : 'each ') + 'approx. ' + fmtHalf(o.finishedWidth) + ' finished' + (r.stationary ? '' : ' (covers ' + fmtHalf(r.panelWidth) + ' of rod)'),
      'Fabric Widths': r.seamless ? 'Seamless (railroaded across the roll), ' + o.cuts + ' cut' + (o.cuts === 1 ? '' : 's') + ' per window' : fmtW(o.totalWidths) + ' per window, ' + o.cuts + ' cut' + (o.cuts === 1 ? '' : 's') + ' per window' + (o.k === 1.5 && o.cuts > o.totalWidths ? ' (one cut split in half, half left over)' : (o.k === 1.5 ? ' (half-widths share split cuts)' : '')),
      'Cut Length': fmtIn(o.cutLength) + (r.seamless ? ' per panel along the roll' : ' (finished ' + r2(i.L) + ' + ' + C.HEM_HEADER_IN + ' hem/header' + (r.cut.repeats ? ', rounded up to whole repeats' : '') + ')' + (o.dropNote ? '; half-drop: ' + o.dropNote : '')),
      'Pattern Repeat': i.vr > 0 ? fmtIn(i.vr) + ' vertical, ' + (i.match === 'drop' ? (i.drop === 0.25 ? 'quarter-drop' : 'half-drop') : i.match) + ' match' + (i.match !== 'random' && !r.seamless ? ' (+1 repeat for placement)' : '') : 'None',
      'Fabric Width': r2(i.fw) + ' in' + (i.widthNote ? ' (DEFAULT - width on file missing/invalid, confirm)' : '') + (i.railroaded ? ', railroaded' : '')
    };
    if (i.own) {
      var comColor = sanitize(val('customFabricColor'));
      props['Fabric'] = sanitize(val('customFabricName')) + (comColor ? ' - ' + comColor : '') + ' (Customer Fabric)';
      props['COM Yardage to Send'] = o.comYards + ' yards';
      props['COM Specs'] = 'width ' + r2(i.fw) + ' in; vertical repeat ' + (i.vr > 0 ? fmtIn(i.vr) : 'none') + '; match ' + (val('comMatch') || 'straight') + (i.railroaded ? '; railroaded' : '');
    } else {
      props['Fabric'] = selectedFabric.title + ' (' + FM().label(o.fabricQty, selectedFabric) + ')';
      props['_Fabric Cost'] = FM().label(o.fabricQty, selectedFabric) + ' @ ' + money(cents(selectedFabric.price)) + FM().per(selectedFabric) + ' = ' + money(o.fabricC);
      props['Fabric Yardage'] = 'needed ' + r2(o.rawYards) + ' yd, ordered ' + FM().label(o.fabricQty, selectedFabric) + (o.minApplied ? ' (fabric minimum)' : '');
    }
    if (cfg.mode === 'outdoor') {
      props['Lining'] = 'None (unlined outdoor)';
      props['Hem / Weights'] = val('hemOption') || 'Standard Hem';
      props['Use'] = 'Outdoor';
    } else {
      var ls = $('draperyLiner');
      props['Lining'] = ls ? ls.options[ls.selectedIndex].text + (o.liningYards ? ' (included)' : '') : 'No Liner';
      if (o.liningYards) props['_Lining Detail'] = o.liningYards + ' yd, ' + o.liningCuts + ' widths of 54" cut ' + r2(i.L + C.LINING_EXTRA_IN) + ' in' + (o.interliningYards ? '; interlining ' + o.interliningYards + ' yd' : '');
      if (o.interliningYards) props['Interlining'] = 'Yes';
    }
    var tp = i.trimPlacement;
    props['Trim Placement'] = tp === 'none' ? 'None' : tp;
    if (tp === 'none') props['Trim'] = 'None';
    else if (i.ownTrim) { var tc = sanitize(val('customTrimColor')); props['Trim'] = sanitize(val('customTrimName')) + (tc ? ' - ' + tc : '') + ' (Customer Trim, ' + o.trimYards + ' yd)'; }
    else { props['Trim'] = selectedTrim.title + ' (' + o.trimYards + ' yards)'; props['_Trim Cost'] = o.trimYards + ' yards @ ' + money(cents(selectedTrim.price)) + '/yd = ' + money(o.trimC); }
    props[cfg.mode === 'outdoor' ? 'Grommet Finish' : 'Grommet Color'] = heading === 'Flat Panel w/ Grommets' ? val('grommetColor') : 'N/A';
    /* TRH 2026-10-30 hide breakdown: internal cost lines are underscore (hidden in cart/checkout, kept on the order in admin) */
    props['_Labor'] = money(o.laborDollars * 100) + (o.laborMinApplied ? ' (workroom minimum)' : '');
    props['_Labor Detail'] = laborLine(o, r, i) + '; face ' + money(o.breakdown.faceC) +
      (o.liningYards ? '; lining ' + o.liningYards + ' yd ' + money(o.breakdown.liningMatC) + ' + lining labor ' + money(o.breakdown.liningLaborC) : '') +
      (o.interliningYards ? '; interlining ' + o.interliningYards + ' yd ' + money(o.breakdown.interMatC) + ' + interlining labor ' + money(o.breakdown.interLaborC) : '') +
      (o.breakdown.trimLaborC ? '; trim sewing ' + money(o.breakdown.trimLaborC) : '') + (o.pleats ? '; approx. ' + o.pleats + ' pleats' : '');
    props['Additional Notes'] = sanitize(val('additionalNotes')) || 'None';
    props['_group_id'] = gid;
    props['_drapery_labor'] = 'true';
    props['_window_count'] = String(i.q);
    props['_calc'] = 'v3';

    var items = [{ id: cfg.draperyVariantId, quantity: o.laborDollars, properties: props }];
    if (!i.own && selectedFabric && selectedFabric.id) {
      items.push({ id: parseInt(selectedFabric.id, 10), quantity: o.fabricQty, properties: {
        '_group_id': gid, '_is_sub_item': 'true', 'For': forWord + room, 'Yardage': FM().label(o.fabricQty, selectedFabric) } });
    }
    if (tp !== 'none' && !i.ownTrim && selectedTrim && selectedTrim.id) {
      items.push({ id: parseInt(selectedTrim.id, 10), quantity: o.trimYards, properties: {
        '_group_id': gid, '_is_sub_item': 'true', 'For': forWord + room, 'Trim Placement': tp } });
    }
    return items;
  }

  function msg(html, isError) {
    var el = $('item_added_message'), span = $('cartMessage'), bar = $('loadingBar'), view = $('viewCartButton'), icon = $('success-icon');
    if (bar) bar.style.display = 'none';
    if (span) { span.style.display = 'block'; span.innerHTML = html; }
    if (view) view.style.display = isError ? 'none' : 'block';
    if (icon) icon.style.display = isError ? 'none' : 'block';
    if (el) { el.classList.toggle('error', !!isError); el.style.display = 'flex'; }
  }

  function addToCart() {
    Object.keys(ERR_FIELD).forEach(function (k) { touched[ERR_FIELD[k]] = true; });
    render();                               /* always recompute from the current inputs */
    var i = readInputs(), probs = inputProblems(i, true);
    showErrors(probs, true);
    if (probs.length || !last) {
      var ce = $('calculateError'); if (ce) { ce.textContent = 'Please complete the highlighted fields.'; ce.style.display = 'block'; }
      var first = $(ERR_FIELD[probs[0]]); if (first && first.scrollIntoView) first.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }
    var ce2 = $('calculateError'); if (ce2) ce2.style.display = 'none';
    if (!cfg.draperyVariantId) { msg('Configuration error: drapery variant not found.', true); return; }
    var btn = $('addToCartButton'), bb = $('trhDc3Bar') && $('trhDc3Bar').querySelector('button');
    [btn, bb].forEach(function (b) { if (b) { b.disabled = true; b.textContent = 'Adding to Cart...'; } });
    var items = buildItems();
    window.__trhLastCartItems = items;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (resp) {
        if (!resp.ok) return resp.json().then(function (d) { throw new Error(d.description || d.message || 'Failed to add to cart'); });
        return resp.json();
      })
      .then(function () { msg('Successfully added to cart!', false); })
      .catch(function (err) { msg('<strong>Error adding to cart</strong><br>' + esc(err.message), true); })
      .then(function () { [btn, bb].forEach(function (b) { if (b) { b.disabled = false; b.textContent = 'Add to Cart'; } }); updateBar(); });
  }

  /* ------------------------------------------------------------------ fabric details */
  function fetchFabricMeta(fabric) {
    var seq = ++metaSeq;
    fabricMeta = null;
    if (!fabric || !fabric.id || !cfg.storeDomain || !cfg.storefrontToken) { metaLoading = false; render(); return; }
    metaLoading = true; render();
    var f = function (k) { return k + ': metafield(namespace: "custom", key: "' + k + '") { value }'; };
    var q = 'query($id: ID!) { node(id: $id) { ... on ProductVariant { product { ' +
      ['width', 'vertical_repeat', 'horizontal_repeat', 'repeat', 'pattern_match', 'railroaded'].map(f).join(' ') + ' description } } } }';
    fetch('https://' + cfg.storeDomain + '/api/' + cfg.apiVersion + '/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': cfg.storefrontToken },
      body: JSON.stringify({ query: q, variables: { id: 'gid://shopify/ProductVariant/' + String(fabric.id).split('/').pop() } })
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (seq !== metaSeq) return;
      var p = d && d.data && d.data.node && d.data.node.product;
      var g = function (k) { return p && p[k] ? p[k].value : null; };
      var w = parseInches(g('width'), false);
      var vr = parseInches(g('vertical_repeat'), false);
      if (vr == null) vr = parseInches(g('repeat'), true);
      var m = parseMatch(g('pattern_match'), g('railroaded'));
      var hr0 = parseInches(g('horizontal_repeat'), false) || 0, fromDesc = false;   /* TRH 2026-10-30: description fallback */
      var dsc = window.TRHRepeatBox && p && p.description ? window.TRHRepeatBox.parseText(p.description) : null;
      if (dsc) { if (vr == null && dsc.vr) { vr = dsc.vr; fromDesc = true; } if (!hr0 && dsc.hr) { hr0 = dsc.hr; fromDesc = true; } if (!g('pattern_match') && dsc.match) { m.match = dsc.match; m.drop = dsc.drop; } }
      fabricMeta = { width: w, vr: vr || 0, hr: hr0, fromDesc: fromDesc, match: m.match, drop: m.drop, railroaded: m.railroaded,
        raw: { width: g('width'), vertical_repeat: g('vertical_repeat'), repeat: g('repeat'), pattern_match: g('pattern_match'), railroaded: g('railroaded') } };
    }).catch(function () {
      if (seq !== metaSeq) return;
      fabricMeta = { width: fabric.fabricWidth || null, vr: 0, match: 'straight', drop: 0, railroaded: false, raw: { error: true } };
    }).then(function () { if (seq !== metaSeq) return; metaLoading = false; render(); });
  }

  /* ------------------------------------------------------------------ UI setup */
  var CSS = [
    '.trh-dc3-head{font-size:13px;color:#555;margin:4px 0 8px;font-weight:normal}',
    '.trh-dc3-grid{display:grid;grid-template-columns:repeat(var(--trh-cols,3),minmax(0,1fr));gap:12px 8px}',
    '.trh-dc3-card{position:relative;display:block;border:1px solid #ccc;border-radius:10px;background:#fff;padding:10px 8px 10px;cursor:pointer;font-weight:normal;font-size:12px;line-height:1.35;color:#333;transition:border-color .15s,box-shadow .15s}',
    '.trh-dc3-card input{position:absolute;opacity:0;width:1px;height:1px;margin:0;padding:0}',
    '.trh-dc3-card.is-sel{border:2px solid #7C8C74;box-shadow:0 2px 8px rgba(124,140,116,.35);padding:9px 7px}',
    '.trh-dc3-card.is-off{background:#f3f3f3;color:#888;cursor:default}',
    '.trh-dc3-card__t{font-weight:700;font-size:13px;margin-bottom:2px}',
    '.trh-dc3-card__s{font-size:11px;color:#777;margin-bottom:6px}',
    '.trh-dc3-card ul{list-style:none;margin:0 0 6px;padding:0}',
    '.trh-dc3-card li{margin:0 0 2px}',
    '.trh-dc3-card__p{font-weight:700;font-size:15px;color:#28a745}',
    '.trh-dc3-each{display:block;font-weight:normal;font-size:11px;color:#777}',
    '.trh-dc3-det{margin-top:6px;font-size:11px;color:#777}',
    '.trh-dc3-det summary{cursor:pointer;color:#7C8C74;font-size:11px}',
    '.trh-dc3-badge{position:absolute;top:-9px;right:6px;background:#DDC762;color:#333;font-size:10px;font-weight:700;border-radius:8px;padding:1px 6px}',
    '.trh-dc3-min{color:#b45309;font-size:11px}',
    '.trh-dc3-hint,.trh-dc3-note{font-size:13px;color:#666;font-weight:normal;font-style:italic;margin:6px 0}',
    '.trh-dc3-total{font-size:18px;font-weight:bold;margin:12px 0 8px;color:#28a745}',
    '.trh-dc3-break{font-size:14px;line-height:1.7;border-top:1px solid #ddd;padding-top:8px;color:#7C8C74;font-weight:normal}',
    '.trh-dc3-break p{margin:0}',
    '.trh-dc3-small{font-size:12px;color:#777}',
    '#trhRepeatInfo{display:block;font-size:12px;color:#555;line-height:1.45;margin-top:4px;font-weight:normal}',
    '#trhComSpecs{display:none;flex-direction:column;gap:10px}',
    '#trhComSpecs label{display:block}',
    '#trhComSpecs .trh-dc3-row{display:flex;align-items:center;gap:8px}',
    '#trhComSpecs .trh-dc3-row input{width:auto;margin:0}',
    '.trh-dc3-bar{display:none}',
    '@media (max-width:749px){',
    '  .trh-dc3-grid{grid-template-columns:1fr;gap:10px}',
    '  .trh-dc3-card{display:grid;grid-template-columns:1fr auto;column-gap:10px;padding:12px}',
    '  .trh-dc3-card.is-sel{padding:11px}',
    '  .trh-dc3-card__p{grid-column:2;grid-row:1 / span 3;align-self:center;font-size:17px}',
    '  .trh-dc3-card ul{grid-column:1}',
    '  .trh-dc3-det{grid-column:1 / -1}',
    '  .trh-dc3-bar{position:fixed;left:0;right:0;bottom:0;z-index:999;background:#fff;border-top:1px solid #ddd;box-shadow:0 -4px 12px rgba(0,0,0,.12);padding:10px 14px calc(10px + env(safe-area-inset-bottom));align-items:center;gap:12px}',
    '  .trh-dc3-bar.is-on{display:flex}',
    '  .trh-dc3-bar__s{flex:1;font-size:13px;line-height:1.3;color:#333}',
    '  .trh-dc3-bar__s b{font-size:17px;color:#28a745}',
    '  .trh-dc3-bar button{flex:0 0 auto;width:auto!important;margin:0!important;background:#DDC762;color:#fff;border:none;border-radius:6px;font-size:15px;font-weight:600;text-transform:uppercase;padding:12px 18px}',
    '  .trh-dc3-bar button:disabled{background:#a3cfbb}',
    '}'
  ].join('\n');

  function el(html) { var d = document.createElement('div'); d.innerHTML = html.trim(); return d.firstChild; }

  function setupUI() {
    var st = document.createElement('style'); st.id = 'trh-dc3-css'; st.textContent = CSS; document.head.appendChild(st);

    /* Live pricing: the Calculate button is no longer needed */
    var calc = $('calculateButton'); if (calc) calc.style.display = 'none';

    /* repeat / width info under the fabric width field */
    var fwf = $('draperyFabricWidth');
    if (fwf && !$('trhRepeatInfo')) fwf.parentNode.insertBefore(el('<span id="trhRepeatInfo" aria-live="polite"></span>'), fwf.nextSibling);
    var fwErr = $('fabricWidthError'); if (fwErr) fwErr.textContent = 'Fabric width must be between 20 and 130 inches.';
    if (fwf) fwf.min = String(C.MIN_VALID_WIDTH);

    /* COM specs (shown with "Use My Own Fabric") */
    var colorLbl = $('customFabricColor') ? $('customFabricColor').parentElement : null;
    if (colorLbl && !$('trhComSpecs')) {
      var com = el('<div id="trhComSpecs">' +
        '<p class="note" style="margin:0">Enter your fabric\u2019s details below (fabric width is the field further down). We\u2019ll show how much to send. You pay labor and options only.</p>' +
        '<label for="comRepeat">Vertical Pattern Repeat (inches):' +
        '<input type="number" id="comRepeat" min="0" step="any" inputmode="decimal" placeholder="0 for plain fabric">' +
        '<span id="comRepeatError" class="error">Enter 0 or a positive number.</span></label>' +
        '<label for="comMatch">Pattern Match:<select id="comMatch">' +
        '<option value="straight">Straight match</option><option value="half-drop">Half-drop match</option><option value="none">Random / no match (plain)</option></select><span class="trh-pm-help" style="display:block;font-size:11.5px;color:#777;line-height:1.4;font-weight:normal;margin:4px 0 0">Not sure? Check your fabric\u2019s label or listing. Motifs in level rows across the fabric = Straight. Motifs staggered diagonally = Half-drop (uses a little more fabric). Solids, linens and textures = Random.</span></label>' +
        '<label class="trh-dc3-row" for="comRailroaded"><input type="checkbox" id="comRailroaded"> My fabric is railroaded (pattern runs across the roll)</label>' +
        '</div>');
      colorLbl.parentNode.insertBefore(com, colorLbl.nextSibling);
    }

    /* draw: add stationary side panels + number-of-panels field */
    var dr = $('drawOption');
    if (dr && !dr.querySelector('option[value="Stationary Side Panels"]')) {
      var op = document.createElement('option'); op.value = 'Stationary Side Panels'; op.textContent = 'Stationary side panels (decorative, don\u2019t close)';
      dr.appendChild(op);
      var tip = dr.parentElement && dr.parentElement.querySelector('.help-icon');
      if (tip) tip.setAttribute('data-tip', 'Pair: two panels that close at the center. One-way: one panel that draws to one side. Stationary side panels: decorative panels that frame the window and don\u2019t close; you choose how many and how wide.');
      var drLbl = dr.closest('label') || dr.parentElement;
      if (drLbl && !$('statPanels')) {
        drLbl.parentNode.insertBefore(el('<label for="statPanels" id="statPanelsWrap" style="display:none">Number of panels per window:' +
          '<input type="number" id="statPanels" min="1" max="12" step="1" value="2" inputmode="numeric">' +
          '<span class="note" style="display:block;font-size:12px;color:#777;font-weight:normal">2 = one on each side of the window.</span>' +
          '<span id="statPanelsError" class="error">Enter 1 to 12 panels.</span></label>'), drLbl.nextSibling);
      }
    }
    /* TRH 2026-10-30 interlining add-on (indoor only), default off, needs a lining */
    var lnr = $('draperyLiner');
    if (cfg.mode !== 'outdoor' && lnr && !$('draperyInterlining')) {
      var lnLbl = lnr.closest('label') || lnr.parentElement;
      lnLbl.parentNode.insertBefore(el('<label for="draperyInterlining" id="draperyInterliningWrap" style="display:flex;align-items:flex-start;gap:8px;font-weight:normal">' +
        '<input type="checkbox" id="draperyInterlining" style="width:auto;margin:3px 0 0">' +
        '<span>Add interlining <span class="note" style="display:block;font-size:12px;color:#777">A soft layer between the fabric and lining for extra body, insulation and light control. Choose a white or blackout liner to add it.</span></span></label>'), lnLbl.nextSibling);
    }
    /* windows multiplier */
    var qf = $('draperyQuantity');
    if (qf) {
      qf.max = String(C.MAX_WINDOWS);
      var ql = qf.closest('label');
      if (ql && ql.firstChild && ql.firstChild.nodeType === 3) ql.firstChild.textContent = 'How many windows like this? ';
      if (ql && !$('trhQtyNote')) ql.insertBefore(el('<span id="trhQtyNote" style="display:block;font-size:12px;color:#777;font-weight:normal">Identical windows are made together and priced as one order (1\u2013' + C.MAX_WINDOWS + ').</span>'), qf);
      var qe = $('quantityError'); if (qe) qe.textContent = 'Enter 1 to ' + C.MAX_WINDOWS + ' windows (for more, please contact us).';
    }

    /* option cards above the result summary */
    var res = $('draperyResult');
    if (res && !$('trhOptions')) res.parentNode.insertBefore(el('<div id="trhOptions" class="trh-dc3-options"></div>'), res);

    /* mobile sticky add-to-cart bar */
    if (!$('trhDc3Bar')) {
      var bar = el('<div id="trhDc3Bar" class="trh-dc3-bar" role="region" aria-label="Add to cart"><div class="trh-dc3-bar__s"></div><button type="button">Add to Cart</button></div>');
      document.body.appendChild(bar);
      bar.querySelector('button').addEventListener('click', addToCart);
      var wrap = $('draperyCalculatorWrapper') || $('draperyCalculator');
      var real = $('addToCartButton');
      if ('IntersectionObserver' in window && wrap && real) {
        var inCalc = false, realVis = false;
        var upd = function () { bar.classList.toggle('is-on', inCalc && !realVis); };
        new IntersectionObserver(function (es) { inCalc = es[0].isIntersecting; upd(); }).observe(wrap);
        new IntersectionObserver(function (es) { realVis = es[0].isIntersecting; upd(); }).observe(real);
      }
    }
  }

  function syncOwnFabric() {
    var own = $('ownFabric') && $('ownFabric').checked;
    var show = function (id, on) { var e = $(id); if (e && e.parentElement) e.parentElement.style.display = on ? 'block' : 'none'; };
    show('customFabricName', own); show('customFabricColor', own);
    var specs = $('trhComSpecs'); if (specs) specs.style.display = own ? 'flex' : 'none';
    var ff = $('singleFabricField'), bb = $('browseFabricsBtn'), sw = $('fabricSwatchPreview'), fw = $('draperyFabricWidth');
    if (ff) {
      ff.disabled = own;
      ff.value = own ? '' : (selectedFabric ? selectedFabric.title + ' ($' + Number(selectedFabric.price).toFixed(2) + FM().per(selectedFabric) + ')' : '');
      ff.classList.toggle('selected', !own && !!selectedFabric);
    }
    if (bb) bb.disabled = own;
    if (sw) sw.style.display = own ? 'none' : (selectedFabric ? 'flex' : 'none');
    if (fw) {
      if (own) { fw.removeAttribute('readonly'); fw.style.background = '#fff'; }
      else { fw.setAttribute('readonly', 'readonly'); fw.style.background = '#f0f0f0'; if (!selectedFabric) fw.value = C.DEFAULT_WIDTH; }
    }
  }

  function syncTrim() {
    var tp = val('draperyTrim') || 'none', own = $('ownTrim') && $('ownTrim').checked;
    var tf = $('singleTrimField'), bb = $('browseTrimsBtn'), ot = $('ownTrim');
    if (tp === 'none') {
      if (ot) { ot.checked = false; } own = false;
      selectedTrim = null;
      if (tf) { tf.value = ''; tf.classList.remove('selected'); }
      var sug = $('trimSearchSuggestions'); if (sug) sug.style.display = 'none';
      var sp = $('trimSwatchPreview'); if (sp) sp.style.display = 'none';
    }
    if (tf) tf.disabled = tp === 'none' || own;
    if (bb) bb.disabled = tp === 'none' || own;
    if (ot) ot.disabled = tp === 'none';
    var show = function (id, on) { var e = $(id); if (e && e.parentElement) e.parentElement.style.display = on ? 'block' : 'none'; };
    show('customTrimName', own && tp !== 'none'); show('customTrimColor', own && tp !== 'none');
    if (own) { selectedTrim = null; if (tf) { tf.value = ''; tf.classList.remove('selected'); } }
  }

  function syncDraw() {
    var stat = val('drawOption') === 'Stationary Side Panels';
    var w = $('statPanelsWrap'); if (w) w.style.display = stat ? 'block' : 'none';
    var wf = $('draperyWidth');
    if (wf) { if (stat) { wf.removeAttribute('required'); wf.placeholder = 'Optional for stationary panels'; } else { wf.setAttribute('required', 'required'); wf.placeholder = 'Enter width in inches'; } }
  }

  function syncInterlining() {
    var cb = $('draperyInterlining'); if (!cb) return;
    var lined = (parseFloat(val('draperyLiner')) || 0) > 0;
    cb.disabled = !lined; if (!lined) cb.checked = false;
    var w = $('draperyInterliningWrap'); if (w) w.style.opacity = lined ? '1' : '.55';
  }

  function syncGrommet() {
    var g = $('grommetColor'); if (!g) return;
    var on = val('pleatOption') === 'Flat Panel w/ Grommets';
    g.parentElement.style.display = on ? 'block' : 'none';
    if (!on) g.value = '';
  }

  function bind() {
    var ids = ['roomName', 'draperyWidth', 'draperyLength', 'draperyFabricWidth', 'draperyQuantity', 'grommetColor', 'drawOption',
      'draperyLiner', 'hemOption', 'customFabricName', 'customFabricColor', 'customTrimName', 'customTrimColor', 'pleatOption',
      'draperyTrim', 'comRepeat', 'comMatch', 'comRailroaded', 'additionalNotes', 'statPanels', 'draperyInterlining'];
    ids.forEach(function (id) {
      var e = $(id); if (!e) return;
      var h = function () {
        if (id === 'pleatOption') syncGrommet();
        if (id === 'drawOption') syncDraw();
        if (id === 'draperyTrim') syncTrim();
        if (id === 'draperyLiner') syncInterlining();
        render();
      };
      e.addEventListener('input', h); e.addEventListener('change', h);
      e.addEventListener('blur', function () { touched[id] = true; render(); });
    });
    var of = $('ownFabric'); if (of) of.addEventListener('change', function () { syncOwnFabric(); render(); });
    var ot = $('ownTrim'); if (ot) ot.addEventListener('change', function () { syncTrim(); render(); });
    var add = $('addToCartButton'); if (add) add.addEventListener('click', addToCart);
    var reset = $('resetButton'); if (reset) reset.addEventListener('click', function () { location.reload(); });
    var box = $('trhOptions');
    if (box) box.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'trhDc3Opt') { chosenKey = e.target.value; render(); }
    });
    document.addEventListener('trh:fabric-selected', function (ev) {
      var d = ev.detail && ev.detail.fabric ? ev.detail.fabric : ev.detail;
      if (!d) return;
      selectedFabric = {
        id: d.variantId || d.id || null, title: d.title || '', price: Number(d.price) || 0,
        fabricWidth: d.fabricWidth || null, minQty: d.minQty || null, unit: d.unit || null,
        tags: d.tags || null, vendor: d.vendor || '', productType: d.productType || ''
      };
      touched.singleFabricField = true;
      if ($('ownFabric') && $('ownFabric').checked) { $('ownFabric').checked = false; syncOwnFabric(); }
      fetchFabricMeta(selectedFabric);
    });
    document.addEventListener('trh:fabric-cleared', function () { selectedFabric = null; fabricMeta = null; metaSeq++; metaLoading = false; syncOwnFabric(); render(); });
    document.addEventListener('trh:trim-selected', function (ev) {
      var t = ev.detail && ev.detail.trim ? ev.detail.trim : ev.detail; if (!t) return;
      selectedTrim = { id: t.variantId || t.id || null, title: t.title || '', price: Number(t.price) || 0, vendor: t.vendor || '', tags: t.tags || [] };
      render();
    });
    document.addEventListener('trh:trim-cleared', function () { selectedTrim = null; render(); });
  }

  function start() { setupUI(); syncGrommet(); syncTrim(); syncOwnFabric(); syncDraw(); syncInterlining(); bind(); render(); }

  function init(config) {
    config = config || {};
    Object.keys(config).forEach(function (k) { if (config[k] != null) cfg[k] = config[k]; });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  }

  window.TRHDraperyCalculator = {
    version: 'v3',
    init: init,
    calculate: render,
    compute: compute,
    parseInches: parseInches,
    parseMatch: parseMatch,
    checkWidth: checkWidth,
    constants: C,
    fullness: FULLNESS_MAP,
    getState: function () {
      var o = chosen();
      return {
        selectedFabric: selectedFabric, selectedTrim: selectedTrim, fabricMeta: fabricMeta, metaLoading: metaLoading,
        inputs: last ? last.i : null, result: last ? last.r : null, chosen: o,
        hasCalculated: !!o, lastCalculatedPrice: o ? o.totalC / 100 : 0,
        lastCalculatedYards: o ? { fabric: o.fabricQty, trim: o.trimYards } : { fabric: 0, trim: 0 }
      };
    },
    selectOption: function (key) { chosenKey = key; render(); },
    buildCartItems: function () { return last ? buildItems() : null; },
    setFabric: function (f) { document.dispatchEvent(new CustomEvent('trh:fabric-selected', { detail: { fabric: f } })); },
    setTrim: function (t) { document.dispatchEvent(new CustomEvent('trh:trim-selected', { detail: { trim: t } })); }
  };
})();
